import React, { useMemo } from "react";
import CustomCard from "../Card";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../molecules/ReactEchart";

const CaseAge: React.FC = React.memo(() => {
  const options: EChartsOption = useMemo(
    () => ({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params: any) => {
          const { value } = params[0];
          return `${value}K`;
        },
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "12%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: ["8 Days", "15 Days", "30 Days", "45 Days", "60 Days"],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          fontSize: 12,
          color: "#1F5782",
          interval: 0,
        },
      },
      yAxis: {
        type: "value",
        splitLine: {
          show: true,
          lineStyle: { color: "#E0E0E0", type: "solid" },
        },
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          show: false,
        },
      },
      series: [
        {
          type: "bar",
          data: [2.5, 3.0, 5.2, 4.5, 3.8],
          barWidth: "40%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0],
            color: ({ dataIndex }) => (dataIndex === 2 ? "#0E3D5D" : "#1F5782"), // ✅ Highlights Masonry bar
          },
          label: {
            show: false,
            position: "top",
            fontSize: 14,
            fontWeight: "bold",
            formatter: ({ value }) => `${value}K`,
            color: "#1F5782",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 14,
              fontWeight: "bold",
              formatter: ({ value }) => `${value}K`,
              color: "#1F5782",
            },
          },
        },
      ],
    }),
    []
  );

  return (
    <CustomCard heading="CASES" subHeading="/ CASE AGE (DAYS)">
      <ReactEchart
        options={options}
        style={{ height: "400px", width: "100%" }}
      />
    </CustomCard>
  );
});

export default CaseAge;
